import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import View from 'view/base';
import View_Feedback_Thread from 'view/feedback_viewer/thread';

export default View.extend({
    className: 'feedback-sidebar-comments',

    inbox_mode: false,

    views: {
        thread : {}
    },

    events: {
        'click .region-thread-screenshot .header' : 'onToggleScreenshotComments',
        'mouseenter .region-thread-screenshot'    : 'onPreviewScreenshotEnter',
        'mouseleave .region-thread-screenshot'    : 'onPreviewScreenshotLeave',
        'dragover'                                : 'onDragOver',
        'drop'                                    : 'onDrop'
    },

    dom_handlers: {
        onToggleScreenshotComments: function(e) {
            $(e.currentTarget).parent().toggleClass('open');
        },

        onPreviewScreenshotEnter: function(e) {
            if (this.inbox_mode) {
                return;
            }

            var screenshot_num = $(e.currentTarget).data('val');
            this.dispatcher.trigger('Sidebar::Preview::Screenshot', true, screenshot_num);
        },

        onPreviewScreenshotLeave: function(e) {
            if (this.inbox_mode) {
                return;
            }

            this.dispatcher.trigger('Sidebar::Preview::Screenshot', false);
        },
        onDragOver: function(e) {
            e.preventDefault();
            // To prevent the default behavior of the browser
            // when a file is dragged and dropped into the browser window
            // (it opens the file in the browser)
        },
        onDrop: function(e) {
            e.preventDefault();
            // To prevent the default behavior of the browser
            // when a file is dragged and dropped into the browser window
            // (it opens the file in the browser)
        }
    },

    event_handlers: {
        onCommentAdd: function(model) {
            if (model.get('feedback_id') !== this.model.get('id')) {
                return;
            }

            if (model.get('reply_comment_id')) {
                return;
            }

            if (model.get('screen_x') || model.get('video_number') || model.get('video_time')) {
                // new bookmark
                if (model.get('video_time')) {
                    var region = $('<div>').addClass('region-thread-video').attr('data-val', model.id);
                    region.prependTo(this.$el.children('div:last'));
                }

                var view = this.newThreadView(model);

                this.renderThread(view);
                view.openReply();

                // new bookmark
                if (model.get('video_time')) {
                    view.el.scrollIntoView();
                    view.focusEditor();
                }
            }
        },

        onCommentRemove: function(model) {
            if (model.get('feedback_id') !== this.model.get('id')) {
                return;
            }

            if (model.get('reply_comment_id')) {
                return;
            }

            if (model.get('screen_x') || model.get('video_number') || model.get('video_time')) {
                if (this.views.thread['_' + model.id]) {
                    // delete thread view
                    this.views.thread['_' + model.id].remove();
                    delete this.views.thread['_' + model.id];

                    // update thread comment count
                    var screenshot_num = model.get('screenshot_num');
                    var pin_comments = this.getPinComments(screenshot_num, true);

                    this.$el.find('.region-thread-screenshot[data-val="' + screenshot_num + '"]').find('.comment-count').text(pin_comments.length);
                }

                this.$el.find('.region-thread-video:empty').remove();
            }
        },

        onViewComments: function(comment_id) {
            if (!comment_id) {
                return;
            }

            var model = Cache.feedback_comment.get(comment_id);

            if (!model) {
                return;
            }

            if (model.get('feedback_id') !== this.model.get('id')) {
                return;
            }

            // screenshot comment
            if (model.get('screen_x')) {
                // open screenshot
                this.$el.find('.region-thread-screenshot[data-val="' + model.get('screenshot_num') + '"]').addClass('open');
            }

            var thread_view = this.views.thread['_' + comment_id];
            if (thread_view) {
                setTimeout(() => {
                    this.views.thread['_' + comment_id].el.scrollIntoView();
                }, 0);
            }
        }
    },

    initialize: function(options) {
        this.dispatcher = options.dispatcher;
        this.inbox_mode = !!options.inbox_mode;

        // comment view
        var thread_count = 0;

        // description thread
        this.newThreadView();
        thread_count++;

        // pin comments
        Cache.feedback_comment.where({feedback_id: this.model.id}).forEach((model) => {
            if (!model.get('reply_comment_id') && (model.get('screen_x') || model.get('video_number') || model.get('video_time'))) {
                this.newThreadView(model);
                thread_count++;
            }
        });

        this.listenTo(Cache.feedback_comment, 'add',    this.event_handlers.onCommentAdd);
        this.listenTo(Cache.feedback_comment, 'remove', this.event_handlers.onCommentRemove);

        // pin comments
        this.dispatcher.on('Sidebar::View::Comments', this.event_handlers.onViewComments.bind(this));

        // video bookmark
        this.dispatcher.on('Pin_Comment:Open', this.event_handlers.onViewComments.bind(this));
    },

    getChildComments: function(parent_id) {
        var models = [];

        Cache.feedback_comment.where({reply_comment_id: parent_id}).forEach((model) => {
            models.push(model);
            models = models.concat(this.getChildComments(model.id));
        });

        return models;
    },

    getPinComments: function(screenshot_num, include_replies) {
        var models = [];

        Cache.feedback_comment.where({feedback_id: this.model.id, reply_comment_id: 0, screenshot_num: screenshot_num}).forEach((model) => {
            if (model.get('screen_number') > 0) {
                models.push(model);
            }
        });

        if (include_replies) {
            models.forEach((model) => {
                models = models.concat(this.getChildComments(model.id));
            });
        }

        return models;
    },

    newThreadView: function(model) {
        var view_index = model ? model.id : 'desc';

        this.views.thread['_' + view_index] = new View_Feedback_Thread({
            model      : model,
            feedback   : this.model,
            dispatcher : this.dispatcher
        });

        return this.views.thread['_' + view_index];
    },

    renderThread: function(new_view) {
        var container;

        if (new_view.model) {
            if (new_view.model.get('video_number') || new_view.model.get('video_time')) {
                container = this.$el.find('.region-thread-video[data-val="' + new_view.model.id + '"]');
            } else {
                var screenshot_num = new_view.model.get('screenshot_num');
                container = this.$el.find('.region-thread-screenshot[data-val="' + screenshot_num + '"] > .content');
            }

            // something is wrong, render the thread in the main body
            if (!container.length) {
                container = this.$el;
            }
        } else {
            container = this.$el.find('.region-thread-desc');
        }

        new_view.render().$el.appendTo(container);
        new_view.show();
    },

    render: function() {
        var screenshots = Cache.feedback_screenshot.where({feedback_id: this.model.id});
        var screenshot_regions = '';
        screenshots.forEach((model, index) => {
            if (this.getPinComments(index).length) {
                screenshot_regions +=
                '<div class="region-thread-screenshot open" data-val="' + index + '">' +
                    (screenshots.length > 1 ?
                    '<div class="header">' +
                        '<span>Screenshot ' + (index + 1) + '</span>' +
                        '<span class="comment-count badge-secondary-invert badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.getPinComments(index, true).length + '</span>' +
                    '</div>' : '')+
                    '<div class="content"></div>' +
                '</div>';
            }
        });

        var video_regions = '';
        _.each(this.views.thread, (view) => {
            if (view.model && view.model.get('video_time')) {
                video_regions +=
                '<div class="region-thread-video" data-val="' + view.model.id + '"></div>';
            }
        });

        var content =
        '<div class="region-thread-desc"></div>' +
        '<div>' +
            screenshot_regions + video_regions +
        '</div>';

        this.$el.html(content);

        _.each(this.views.thread, (view) => {
            this.renderThread(view);
            view.openReply();
        });

        return this;
    }
});